import React, { useState } from "react";
import { CopyIcon, CheckIcon } from "@radix-ui/react-icons";
import styles from "./CopyableTextField.module.scss";

const CopyableTextField = ({ text }) => {
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(text).then(() => {
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 2000);
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.text}>{text}</div>
      <button onClick={copyToClipboard} className={styles.copyBtn}>
        {isCopied ? <CheckIcon /> : <CopyIcon />}
      </button>

      {isCopied && <div className={styles.info}>Текст скопирован!</div>}
    </div>
  );
};

export default CopyableTextField;

// Пример использования:
// <CopyableTextField text="Этот текст можно скопировать" />
